'use client';

import { ErrorMessage } from '@/components/(system)/error-message/error-message.component';

import { NarrowWrapper } from '@/styles/global.elements';

const ErrorBoundry = () => {
  return (
    <NarrowWrapper>
      <ErrorMessage />
    </NarrowWrapper>
  );
};

export default ErrorBoundry;
